// import { useState, useEffect, useCallback } from 'react';
// import axiosInstance from '../Datas/AxiosConfig';

// interface NotificationData {
//   success: boolean;
//   unread_count: number;
//   last_checked?: string;
//   new_bids?: any[];
//   new_requests?: any[];
// }

// interface UseNotificationsReturn {
//   unreadCount: number;
//   isLoading: boolean;
//   fetchNotifications: () => Promise<void>;
//   markAsRead: () => Promise<void>;
// }

// /**
//  * Custom hook for managing user notifications
//  * 
//  * @param userType - User type: 'client' | 'clientOfGoogle' | 'clientOfFacebook' | 'craftsman' | null
//  * @returns Notification state and methods
//  * 
//  * Features:
//  * - Auto-polls every 30 seconds
//  * - Supports all user types (JWT, Google, Facebook)
//  * - Handles unread count tracking
//  * - Mark as read functionality
//  */
// export const useNotifications = (userType: string | null): UseNotificationsReturn => {
//   const [unreadCount, setUnreadCount] = useState<number>(0);
//   const [isLoading, setIsLoading] = useState<boolean>(false);

//   /**
//    * Fetch notifications from backend
//    */
//   const fetchNotifications = useCallback(async () => {
//     // ✅ Skip if no valid user type
//     if (!userType || userType === 'unknown') {
//       return;
//     }

//     setIsLoading(true);

//     try {
//       let endpoint = '';
//       const params: any = {};

//       // ✅ Get user data from localStorage
//       const userStr = localStorage.getItem('user');
//       if (!userStr) {
//         setIsLoading(false);
//         return;
//       }

//       const user = JSON.parse(userStr);

//       // ========================================
//       // Determine endpoint and params based on user type
//       // ========================================
      
//       if (
//         userType === 'client' || 
//         userType === 'clientOfGoogle' || 
//         userType === 'clientOfFacebook'
//       ) {
//         // ✅ Client/Author - check for new bids
//         endpoint = 'api/notifications/unread-bids/';
        
//         // ========================================
//         // Extract OAuth IDs based on user_type
//         // ========================================
        
//         if (userType === 'clientOfFacebook' && user.external_Id) {
//           // ✅ Facebook: Extract from email "fb_2674802066206732@xeloba.temp"
//           params.facebook_user_id = user.external_Id;
          
//         } else if (userType === 'clientOfGoogle' && user.external_Id) {
//           // ✅ Google: Use external_Id (Appwrite User ID)
//           params.google_user_id = user.external_Id;
          
//         } else if (userType === 'client') {
//           // ✅ JWT Client - no params needed (uses auth token)
//           // params will be empty, backend uses request.user
//         }
        
//       } else if (userType === 'craftsman') {
//         // ✅ Craftsman - check for new job requests
//         endpoint = 'api/notifications/new-requests/';
//         // JWT auth only, no params needed
        
//       } else {
//         // Unknown user type, skip
//         setIsLoading(false);
//         return;
//       }

//       // ========================================
//       // Make API request
//       // ========================================
      
//       const { data } = await axiosInstance.get<NotificationData>(endpoint, { params });

//       if (data.success && data.unread_count !== undefined) {
//         setUnreadCount(data.unread_count);
//       } else {
//         // If API returns unexpected format, reset to 0
//         setUnreadCount(0);
//       }

//     } catch (error: any) {
//       // ✅ Silent fail - don't show error to user for notifications
//       console.error('Error fetching notifications:', error);
      
//       // If 401/403, user might be logged out - reset count
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         setUnreadCount(0);
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   }, [userType]);

//   /**
//    * Mark all notifications as read
//    */
//   const markAsRead = useCallback(async () => {
//     if (!userType || userType === 'unknown') {
//       return;
//     }

//     // ✅ Optimistic update - set to 0 immediately
//     setUnreadCount(0);

//     try {
//       const userStr = localStorage.getItem('user');
//       if (!userStr) return;

//       const user = JSON.parse(userStr);
//       const payload: any = {};

//       // ========================================
//       // Determine notification type and params
//       // ========================================
      
//       if (
//         userType === 'client' || 
//         userType === 'clientOfGoogle' || 
//         userType === 'clientOfFacebook'
//       ) {
//         payload.type = 'bids';
        
//         // ========================================
//         // Extract OAuth IDs
//         // ========================================
        
//         if (userType === 'clientOfFacebook' && user.email && user.email.startsWith('fb_')) {
//           // ✅ Facebook: Extract from email
//           const fbId = user.email.split('@')[0].replace('fb_', '');
//           payload.facebook_user_id = fbId;
          
//         } else if (userType === 'clientOfGoogle' && user.external_Id) {
//           // ✅ Google: Use external_Id
//           payload.google_user_id = user.external_Id;
          
//         } else if (userType === 'client') {
//           // ✅ JWT Client - no extra params
//         }
        
//       } else if (userType === 'craftsman') {
//         payload.type = 'requests';
//       }

//       // ========================================
//       // Mark as read on backend
//       // ========================================
      
//       await axiosInstance.post('api/notifications/mark-read/', payload);

//     } catch (error) {
//       console.error('Error marking notifications as read:', error);
//       // Don't revert optimistic update - user expects badge to disappear
//     }
//   }, [userType]);

//   // ========================================
//   // Auto-polling effect
//   // ========================================
  
//   useEffect(() => {
//     // Initial fetch
//     fetchNotifications();

//     // Poll every 30 seconds
//     const interval = setInterval(() => {
//       fetchNotifications();
//     }, 30000); // 30 seconds

//     // Cleanup on unmount
//     return () => {
//       clearInterval(interval);
//     };
//   }, [fetchNotifications]);

//   return {
//     unreadCount,
//     isLoading,
//     fetchNotifications,
//     markAsRead
//   };
// };








///////////
// src/Components/Hooks/useNotifications.ts 
// ✅ FIXED: TypeScript Set iteration issues

import { useState, useEffect, useCallback } from 'react';
import axiosInstance from '../Datas/AxiosConfig';

interface NotificationData {
  success: boolean;
  unread_count: number;
  last_checked?: string;
  new_bids?: any[];
  new_requests?: any[];
  job_requests?: any[];
}

interface UseNotificationsReturn {
  unreadCount: number;
  isLoading: boolean;
  fetchNotifications: () => Promise<void>;
  markAsRead: () => Promise<void>;
  markRequestAsViewed: (requestId: number) => void;
  getUnreadBidsPerRequest: () => Record<number, number>;
}

// ============================================
// ✅ HELPER: localStorage key
// ============================================
const getViewedRequestsKey = (userId: string) => {
  return `viewed_job_requests_${userId}`;
};

/**
 * Custom hook for managing user notifications
 * 
 * @param userType - User type: 'client' | 'clientOfGoogle' | 'clientOfFacebook' | 'craftsman' | null
 * @returns Notification state and methods
 * 
 * ✅ Features:
 * - Auto-polls every 30 seconds
 * - Supports all user types (JWT, Google, Facebook)
 * - Tracks viewed requests in localStorage
 * - Per-request unread counts
 */
export const useNotifications = (userType: string | null): UseNotificationsReturn => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  // ✅ Track unread bids per request
  const [unreadBidsPerRequest, setUnreadBidsPerRequest] = useState<Record<number, number>>({});
  
  // ✅ Track viewed requests (localStorage) - FIXED: Use Array instead of Set
  const [viewedRequests, setViewedRequests] = useState<number[]>(() => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return [];
    
    try {
      const user = JSON.parse(userStr);
      const key = getViewedRequestsKey(user.external_Id);
      const stored = localStorage.getItem(key);
      
      if (stored) {
        return JSON.parse(stored);
      }
    } catch {
      return [];
    }
    return [];
  });

  // ============================================
  // ✅ SAVE VIEWED REQUESTS TO LOCALSTORAGE
  // ============================================
  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return;
    
    try {
      const user = JSON.parse(userStr);
      const key = getViewedRequestsKey(user.external_Id);
      localStorage.setItem(key, JSON.stringify(viewedRequests));
    } catch (error) {
      console.error('Error saving viewed requests:', error);
    }
  }, [viewedRequests]);

  /**
   * Fetch notifications from backend
   */
  const fetchNotifications = useCallback(async () => {
    if (!userType || userType === 'unknown') {
      return;
    }

    setIsLoading(true);

    try {
      let endpoint = '';
      const params: any = {};

      const userStr = localStorage.getItem('user');
      if (!userStr) {
        setIsLoading(false);
        return;
      }

      const user = JSON.parse(userStr);

      // ========================================
      // Determine endpoint and params
      // ========================================
      
      if (
        userType === 'client' || 
        userType === 'clientOfGoogle' || 
        userType === 'clientOfFacebook'
      ) {
        // ✅ Client/Author - fetch per-request unread counts
        endpoint = 'api/notifications/job-requests-unread/';
        
        if (userType === 'clientOfFacebook' && user.email && user.email.startsWith('fb_')) {
          const fbId = user.email.split('@')[0].replace('fb_', '');
          params.facebook_user_id = fbId;
        } else if (userType === 'clientOfGoogle' && user.external_Id) {
          params.google_user_id = user.external_Id;
        }
        
      } else if (userType === 'craftsman') {
        // ✅ Craftsman - check for new job requests
        endpoint = 'api/notifications/new-requests/';
        
      } else {
        setIsLoading(false);
        return;
      }

      // ========================================
      // Make API request
      // ========================================
      
      const { data } = await axiosInstance.get<NotificationData>(endpoint, { params });

      if (data.success) {
        // ✅ For clients: process per-request counts
        if (data.job_requests) {
          const unreadCounts: Record<number, number> = {};
          let totalUnread = 0;
          
          data.job_requests.forEach((item: any) => {
            // ✅ FIXED: Use includes() instead of has()
            if (item.unread_bids_count > 0 && !viewedRequests.includes(item.id)) {
              unreadCounts[item.id] = item.unread_bids_count;
              totalUnread += item.unread_bids_count;
            }
          });
          
          setUnreadBidsPerRequest(unreadCounts);
          setUnreadCount(totalUnread);
          
          console.log('📊 Unread per request:', unreadCounts);
          console.log('📊 Total unread:', totalUnread);
        } 
        // ✅ For craftsmen: use unread_count directly
        else if (data.unread_count !== undefined) {
          setUnreadCount(data.unread_count);
        } else {
          setUnreadCount(0);
        }
      } else {
        setUnreadCount(0);
      }

    } catch (error: any) {
      console.error('Error fetching notifications:', error);
      
      if (error.response?.status === 401 || error.response?.status === 403) {
        setUnreadCount(0);
      }
    } finally {
      setIsLoading(false);
    }
  }, [userType, viewedRequests]);

  /**
   * Mark all notifications as read (backend timestamp update)
   */
  const markAsRead = useCallback(async () => {
    if (!userType || userType === 'unknown') {
      return;
    }

    console.log('✅ Marking all notifications as read on backend');

    // ✅ Optimistic update
    setUnreadCount(0);
    setUnreadBidsPerRequest({});

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return;

      const user = JSON.parse(userStr);
      const payload: any = {};

      if (
        userType === 'client' || 
        userType === 'clientOfGoogle' || 
        userType === 'clientOfFacebook'
      ) {
        payload.type = 'bids';
        
        if (userType === 'clientOfFacebook' && user.email && user.email.startsWith('fb_')) {
          const fbId = user.email.split('@')[0].replace('fb_', '');
          payload.facebook_user_id = fbId;
        } else if (userType === 'clientOfGoogle' && user.external_Id) {
          payload.google_user_id = user.external_Id;
        }
        
      } else if (userType === 'craftsman') {
        payload.type = 'requests';
      }

      await axiosInstance.post('api/notifications/mark-read/', payload);
      console.log('✅ Backend marked as read');

    } catch (error) {
      console.error('Error marking notifications as read:', error);
    }
  }, [userType]);

// ============================================
  // ✅ Mark single request as viewed
  // ============================================
  const markRequestAsViewed = useCallback((requestId: number) => {
    console.log('🔔 [Hook] Marking request ' + requestId + ' as viewed');
    console.log('🔔 [Hook] Current viewedRequests:', viewedRequests);
    console.log('🔔 [Hook] Current unreadBidsPerRequest:', unreadBidsPerRequest);
    
    // ✅ Add to viewed array
    setViewedRequests((prev) => {
      console.log('🔔 [Hook] setViewedRequests prev:', prev);
      
      if (prev.includes(requestId)) {
        console.log('🔔 [Hook] Already viewed!');
        return prev;
      }
      
      const updated = [...prev, requestId];
      console.log('🔔 [Hook] setViewedRequests updated:', updated);
      return updated;
    });
    
    // ✅ Remove from unread counts
    setUnreadBidsPerRequest((prev) => {
      const updated = { ...prev };
      const removedCount = updated[requestId] || 0;
      
      console.log('🔔 [Hook] Removing ' + removedCount + ' from unread count');
      delete updated[requestId];
      
      // ✅ Update total unread count
      setUnreadCount((currentCount) => {
        const newCount = Math.max(0, currentCount - removedCount);
        console.log('🔔 [Hook] Unread count: ' + currentCount + ' → ' + newCount);
        return newCount;
      });
      
      return updated;
    });
    
    // ✅ Check if all notifications are now viewed
    setTimeout(() => {
      const allRequestIds = Object.keys(unreadBidsPerRequest).map(Number);
      
      console.log('🔔 [Hook] Checking if all viewed. All IDs:', allRequestIds);
      
      const allViewed = allRequestIds.every(id => 
        id === requestId || viewedRequests.includes(id)
      );
      
      console.log('🔔 [Hook] All viewed?', allViewed);
      
      if (allViewed && allRequestIds.length > 0) {
        console.log('✅ All requests viewed - marking backend as read');
        markAsRead();
      }
    }, 100);
  }, [unreadBidsPerRequest, viewedRequests, markAsRead]);
  
  // ============================================
  // ✅ NEW: Get unread bids per request
  // ============================================
  const getUnreadBidsPerRequest = useCallback(() => {
    return unreadBidsPerRequest;
  }, [unreadBidsPerRequest]);

  // ========================================
  // Auto-polling effect
  // ========================================
  
  useEffect(() => {
    // Initial fetch
    fetchNotifications();

    // Poll every 30 seconds
    const interval = setInterval(() => {
      fetchNotifications();
    }, 30000);

    return () => {
      clearInterval(interval);
    };
  }, [fetchNotifications]);

  return {
    unreadCount,
    isLoading,
    fetchNotifications,
    markAsRead,
    markRequestAsViewed,
    getUnreadBidsPerRequest,
  };
};